import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  PickList,
  PickListModule,
  PickListSourceSelectEvent,
} from 'primeng/picklist';

import { BookmarkCategory } from '../../../models/bookmark-category';
import { DividerModule } from 'primeng/divider';
import { NgIf } from '@angular/common';
import { PrimeTemplate } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { BookmarkCategoryStore } from '../../../stores/bookmark-category/bookmark-category.state';
import { AlertComponent } from '../../atoms/alert/alert.component';

@Component({
  selector: 'app-bookmark-category-pick-list',
  standalone: true,
  imports: [
    DividerModule,
    NgIf,
    PickListModule,
    PrimeTemplate,
    TagModule,
    AlertComponent,
  ],
  templateUrl: './bookmark-category-pick-list.component.html',
  styleUrl: './bookmark-category-pick-list.component.scss',
})
export class BookmarkCategoryPickListComponent implements OnInit, OnDestroy {
  @ViewChild('listPickerCtrl') listPickerCtrl!: PickList;
  @Input() selectedIds?: string[];
  @Input() ignoreChildren = false;
  @Input() keepSelection = false;
  @Input() autoselectParents = false;
  @Input() autoselectChildren = false;
  @Input() showSourceControls = false;
  @Input() showTargetControls = true;
  @Output() selectionChanged = new EventEmitter<string[]>();

  readonly bookmarkCategoryStore = inject(BookmarkCategoryStore);

  selected: BookmarkCategory[] = [];
  source: BookmarkCategory[] = [];

  /**
   * Angular lifecycle hook that is called after the component has been initialized.
   * It sets the `selected` property to the current selection from the bookmarkCategory store.
   *
   * @return {void} Does not return a value.
   */
  ngOnInit(): void {
    if (this.selectedIds) {
      this.selected = this.bookmarkCategoryStore.selectMultiple(
        this.selectedIds
      );
    } else {
      this.selected = this.bookmarkCategoryStore.selection();
    }
    this.source = [...this.bookmarkCategoryStore.asArray()].filter(
      category => !this.selectedIds || !this.selectedIds.includes(category._id)
    );
  }

  /**
   * Updates the selection of items in the bookmarkCategory store and, if autoselectParents is enabled, adds parent items to the selection and updates the local selection state.
   *
   * @return {void} This method does not return a value.
   */
  updateSelection(): void {
    this.bookmarkCategoryStore.updateSelection(this.selected);
    this.selected = this.bookmarkCategoryStore.selection();
    this.selectionChanged.emit(this.selected.map(category => category._id));
  }
  /**
   * A lifecycle hook that is called when the component is destroyed.
   * This method checks the `keepSelection` property and, if it is false, clears the selection in the bookmarkCategory store.
   *
   * @return {void} Does not return a value.
   */
  ngOnDestroy(): void {
    if (this.keepSelection) return;
    this.bookmarkCategoryStore.clearSelection();
  }
}
